import Suggestion from "components/Suggestion";
import Admin from "components/common/Admin";
import CMSTableWithEnquiry from "components/common/CMSTableWithEnquiry";
import React from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

export default function Enquiry() {

    const { user } = useSelector(state => state.global)
    const [search, setSearch] = useSearchParams()

    return (user?.user_roles?.includes('admin') && search.get('pure')) ? <Admin><CMSTableWithEnquiry /></Admin> : <Suggestion type={search.get('type')} />;
}
